import { render, staticRenderFns } from "./ModalOrganosAdministradores.vue?vue&type=template&id=7d57b648"
import script from "./ModalOrganosAdministradores.vue?vue&type=script&lang=js"
export * from "./ModalOrganosAdministradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d57b648')) {
      api.createRecord('7d57b648', component.options)
    } else {
      api.reload('7d57b648', component.options)
    }
    module.hot.accept("./ModalOrganosAdministradores.vue?vue&type=template&id=7d57b648", function () {
      api.rerender('7d57b648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosAdministradores.vue"
export default component.exports